import PersonIcon from '@mui/icons-material/Person';
import BuildIcon from '@mui/icons-material/Build';
import DescriptionIcon from '@mui/icons-material/Description';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CategoryIcon from '@mui/icons-material/Category';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import ChecklistIcon from '@mui/icons-material/Checklist';
import BusinessIcon from '@mui/icons-material/Business';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssessmentIcon from '@mui/icons-material/Assessment';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import StorefrontIcon from '@mui/icons-material/Storefront';
import HistoryIcon from '@mui/icons-material/History';
import ExtensionIcon from '@mui/icons-material/Extension';

// Ícone de cada módulo do plano, por `key` (a lista de módulos, rótulos e textos
// padrão vem do backend em `modules_catalog` — planmodule.Catalog). Módulo novo
// sem ícone aqui cai no ExtensionIcon.
const MODULE_ICONS = {
    customer: PersonIcon,
    order_service: BuildIcon,
    quote: DescriptionIcon,
    sale: ShoppingCartIcon,
    product: CategoryIcon,
    inventory: Inventory2Icon,
    vehicle: DirectionsCarIcon,
    checklist: ChecklistIcon,
    suppliers: BusinessIcon,
    financial: AccountBalanceWalletIcon,
    program_loyalty: LoyaltyIcon,
    dashboard: DashboardIcon,
    report: AssessmentIcon,
    whatsapp: WhatsAppIcon,
    ai_assistant: AutoAwesomeIcon,
    marketplace: StorefrontIcon,
    audit: HistoryIcon,
};

export const getModuleIcon = (key) => MODULE_ICONS[key] || ExtensionIcon;
